import { set } from 'lodash';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../redux/epics/utils';
import { GET_RND_TEAM_MEMBERS } from '../../../../../../common/config/api_endpoints';

export const GET_RND_TEAM_MEMBERS_ACTION_TYPES = createAPILifecycleActionTypes(
  'GET_RND_TEAM_MEMBERS_ACTION_TYPES',
);
export const getRnDTeamMembersAction = createAPILifecycleActions(
  GET_RND_TEAM_MEMBERS_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: [],
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_RND_TEAM_MEMBERS_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case GET_RND_TEAM_MEMBERS_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    case GET_RND_TEAM_MEMBERS_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        error: payload,
      };
    case GET_RND_TEAM_MEMBERS_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

const payloadGenerator = async ({ originalPayload }) => {
  const newPayload = {};
  set(newPayload, ['body'], originalPayload?.body || {});
  return newPayload;
};

const successCallback = response => {
  return [getRnDTeamMembersAction.SUCCESS(response.body || [])];
};

export const getRnDTeamMembersEpic = createAmplifyAPICallEpic({
  actionType: GET_RND_TEAM_MEMBERS_ACTION_TYPES.BEGIN,
  payloadGenerator,
  api: GET_RND_TEAM_MEMBERS,
  successCallback,
  errorCallback: () => [getRnDTeamMembersAction.FAILURE()],
});
